import React, { useState, useEffect, useMemo, useRef } from 'react'
import Styles from './GraphCard.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import IFText from 'Components/IFText/IFText'
import IFSelectPicker from 'Components/IFFilter/IFSelectPicker/IFSelectPicker'
import IFFilterType from 'Enums/IFFilterType'
import IFRefreshComponent from 'Components/IFRefreshComponent/IFRefreshComponent'
import IFSkeleton from 'Components/IFSkeleton/IFSkeleton'

const GraphCard = ({
  title,
  icon,
  isSelectPicker,
  graph: Graph,
  selectTitle,
  selectData,
  selectInitialValue,
  selectIcon,
  refresh,
}) => {
  const refreshRef = useRef()
  const graphRef = useRef()
  const [value, setValue] = useState(selectInitialValue?.value)
  const filter = useMemo(
    () => [
      {
        type: IFFilterType.SELECT,
        title: 'Period',
        data: selectData,
        initialValue: value,
        value: value,
      },
    ],
    [value],
  )

  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    const timeout = setTimeout(() => setIsFirstLoad(false), 300)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div
      style={{
        backgroundColor: Colors.white,
        border: `1px solid ${Colors.ScheduleChartTick}`,
      }}
      className={Styles.Card}
    >
      <div
        className={Styles.TopContainer}
        style={{
          borderBottom: `1px dashed ${Colors.ScheduleChartTick}`,
        }}
      >
        <div className={Styles.Left}>
          <div
            className={Styles.IconContainer}
            style={{ backgroundColor: Colors.Analytics.IconBackground }}
          >
            <div className={Styles.Icon}>
              {isFirstLoad ? (
                <IFSkeleton variant="circular" width={24} height={24} />
              ) : (
                icon
              )}
            </div>
          </div>
          {isFirstLoad ? (
            <IFSkeleton
              variant="text"
              width={120}
              height={24}
              style={{ marginLeft: 8 }}
            />
          ) : (
            <IFText style={{ color: Colors.black }} className={Styles.Title}>
              {title}
            </IFText>
          )}
        </div>

        {!refresh &&
          (isSelectPicker ? (
            isFirstLoad ? (
              <div className={Styles.Date}>
                <IFSkeleton variant="rectangular" width={120} height={36} />
              </div>
            ) : (
              <div
                className={Styles.Date}
                style={{ border: `1px solid ${Colors.ScheduleChartTick}` }}
              >
                <div className={Styles.SelectIcon}> {selectIcon} </div>
                {value && (
                  <IFSelectPicker
                    width={120}
                    title={
                      selectTitle
                        ? selectTitle
                        : selectData.find((item) => item.value === value)
                            ?.label || value
                    }
                    data={selectData.map((item) => item.label)}
                    initialValue={
                      selectData.find((item) => item.value === value)?.label ||
                      value
                    }
                    externalValue={
                      selectData.find((item) => item.value === value)?.label
                    }
                    onValueChange={(selectedLabel) => {
                      const matchedItem = selectData.find(
                        (item) => item.label === selectedLabel,
                      )
                      const camelCase = matchedItem?.value || selectedLabel
                      setValue(camelCase)
                    }}
                  />
                )}
              </div>
            )
          ) : (
            <div
              className={Styles.DateAllTime}
              style={{ border: `1px solid ${Colors.ScheduleChartTick}` }}
            >
              <div className={Styles.SelectIcon}> {selectIcon} </div>
              <IFText>{selectTitle}</IFText>
            </div>
          ))}

        {refresh &&
          (isFirstLoad ? (
            <div className={Styles.Date}>
              <IFSkeleton variant="circular" width={36} height={36} />
            </div>
          ) : (
            <div className={Styles.Date}>
              <IFRefreshComponent ref={refreshRef} graphRef={graphRef} />
            </div>
          ))}
      </div>
      <Graph
        ref={graphRef}
        className={Styles.Graph}
        value={value}
        filter={filter}
        refreshComponentRef={refreshRef}
      />
    </div>
  )
}

GraphCard.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.element,
  isSelectPicker: PropTypes.bool,
  graph: PropTypes.element,
  selectTitle: PropTypes.string,
  selectData: PropTypes.array,
  selectInitialValue: PropTypes.object,
  selectIcon: PropTypes.element,
  refresh: PropTypes.bool,
}

export default GraphCard
